import { DyAbstractLabel, IDyLabel } from './dyAbstractLabel';
import { setDisabled, addOrRemoveCssClass, setFixedWidth, addCssClass } from '../utils/dom';

export type FieldElement = HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement;
export abstract class DyAbstractField<TValue, TConfig extends IDyLabel = IDyLabel> extends DyAbstractLabel<TConfig> {
  public static EVENT_CHANGED = 'valueChange';

  protected previousValue: TValue | null | undefined;
  protected value: TValue | null | undefined;
  protected disabled: boolean = false;

  constructor(config?: TConfig, template?: string, protected readonly className?: string) {
    super(config, template);
  }

  protected postConstruct(): void {
    super.postConstruct();

    if (this.className) {
      addCssClass(this.getGui(), this.className);
    }
  }

  public onValueChange(callbackFn: (newValue?: TValue | null) => void) {
    this.addManagedListener(this, DyAbstractField.EVENT_CHANGED, () => callbackFn(this.getValue()));

    return this;
  }

  public getWidth(): number {
    return this.getGui().clientWidth;
  }

  public setWidth(width: number): this {
    setFixedWidth(this.getGui(), width);

    return this;
  }

  public getPreviousValue(): TValue | null | undefined {
    return this.previousValue;
  }

  public getValue(): TValue | null | undefined {
    return this.value;
  }

  public setValue(value?: TValue | null, silent?: boolean): this {
    if (this.value === value) {
      return this;
    }

    this.previousValue = this.value;
    this.value = value;

    if (!silent) {
      this.dispatchEvent({ type: DyAbstractField.EVENT_CHANGED });
    }

    return this;
  }

  public setDisabled(disabled: boolean): this {
    disabled = !!disabled;

    const element = this.getGui();

    setDisabled(element, disabled);
    addOrRemoveCssClass(element, 'dy-disabled', disabled);

    this.disabled = disabled;

    return this;
  }

  public isDisabled(): boolean {
    return !!this.disabled;
  }
}
